<template>
  <footer class="site-footer">
    <div class="site-footer__main">
      <div class="site-footer__brand">
        <img src="/img/home/brand-logo.webp" alt="Back to Work Connect" width="43" height="48" loading="lazy" />
        <p>Making recruitment more returner-friendly while supporting returners and career changers to take their next step with confidence.</p>
      </div>
      <nav class="site-footer__group" aria-label="Explore">
        <p class="site-footer__label">Explore</p>
        <div class="site-footer__links site-footer__links--explore">
          <a href="/careerhub/blog/">Resources</a>
          <a href="/careerhub/about/">About Us</a>
          <a href="/careerhub/hire-experienced-talent/">Hire Experienced Talent</a>
          <a href="/careerhub/contact/">Contact us</a>
        </div>
      </nav>
      <div class="site-footer__group">
        <p class="site-footer__label">Reach Us On</p>
        <div class="site-footer__links site-footer__links--contact">
          <a href="mailto:info@backtoworkconnect.ie">info@backtoworkconnect.ie<span aria-hidden="true">→</span></a>
          <a href="tel:0894057839">0894057839<span aria-hidden="true">→</span></a>
        </div>
      </div>
    </div>
    <div class="site-footer__bottom">
      <p>© {{ year }} — BackToWorkConnect.ie</p>
      <div class="site-footer__social">
        <a v-for="s in social" :key="s.label" :href="s.url" target="_blank" rel="noopener">{{ s.label }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      social: [
        { label: 'Facebook', url: 'https://www.facebook.com/backtoworkconnect' },
        { label: 'LinkedIn', url: 'https://www.linkedin.com/company/20292620/' },
        { label: 'Instagram', url: 'https://www.instagram.com/backtoworkconnect/' },
      ],
    }
  },
}
</script>

<style scoped>
.site-footer {
  margin-top: 8px;
  background: #A2968C;
  color: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  line-height: normal;
  -webkit-font-smoothing: antialiased;
}
.site-footer a {
  color: #FFFFFF;
  text-decoration: none;
}
.site-footer__main {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 48px 40px;
  padding: 64px clamp(20px, 4vw, 64px) 40px;
}
.site-footer__brand {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
}
.site-footer__brand img {
  display: block;
  align-self: flex-start;
  height: 48px;
  width: auto;
}
.site-footer__brand p {
  margin: 0;
  max-width: 340px;
  font-size: 15px;
  line-height: 1.65;
}
/* Section labels: bold, full white and underlined so they read as headings. */
.site-footer__label {
  margin: 0 0 16px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: .14em;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 6px;
  text-transform: uppercase;
}
.site-footer__links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
.site-footer__links a {
  font-size: 15px;
  font-weight: 600;
}
.site-footer__links a:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
}
.site-footer__links--contact span {
  display: none;
}
.site-footer__bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px clamp(20px, 4vw, 64px);
  background: #560354;
  font-size: 13px;
  color: #F0E6EF;
}
.site-footer__bottom p {
  margin: 0;
}
.site-footer__social {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.site-footer__social a {
  position: relative;
  border: 1px solid rgba(255, 255, 255, .45);
  border-radius: 999px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  transition: background-color .15s, color .15s;
}
.site-footer__social a:hover {
  background: #FFFFFF;
  color: #560354;
}
.site-footer a:focus-visible {
  outline: 3px solid #FFFFFF;
  outline-offset: 3px;
}

/* Phones: one column with dividers, tap cards for contact details. */
@media (max-width: 639px) {
  .site-footer__main {
    display: flex;
    flex-direction: column;
    gap: 28px;
    padding: 40px 20px 32px;
  }
  .site-footer__brand {
    gap: 14px;
  }
  .site-footer__brand img {
    height: 46px;
  }
  .site-footer__brand p {
    max-width: none;
    line-height: 1.6;
  }
  .site-footer__group {
    padding-top: 28px;
    border-top: 1px solid rgba(255, 255, 255, .3);
  }
  .site-footer__label {
    margin-bottom: 14px;
    font-size: 12px;
    letter-spacing: .16em;
  }
  .site-footer__links--explore {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 16px;
  }
  .site-footer__links--explore a {
    padding: 6px 0;
  }
  .site-footer__links--contact {
    align-items: stretch;
  }
  .site-footer__links--contact a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 48px;
    padding: 14px 16px;
    border-radius: 12px;
    background: rgba(255, 255, 255, .14);
  }
  .site-footer__links--contact span {
    display: inline;
    opacity: .8;
  }
  .site-footer__bottom {
    flex-direction: column;
    align-items: stretch;
    padding: 22px 20px;
  }
  .site-footer__bottom p {
    order: 1;
    text-align: center;
    font-size: 12px;
  }
  .site-footer__social {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }
  .site-footer__social a {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 9px 0;
    font-size: 12px;
  }
  /* Keep the pill the designed size but give it a 44px-tall tap area. */
  .site-footer__social a::after {
    content: '';
    position: absolute;
    inset: -6px 0;
  }
}
</style>
